/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */


/**
 * :ZNOTE:
 * tag: journalManage
 * note:
 *  - journalManageの初期化処理
 * sample:
 *  - ほぼ全てのプロジェクト
 * :ZNOTE:
 */

import {JournalManage} from './journalManageClass';


let journalCache: JournalManage;
let journalTableName: string;


const getJournal = async (tableName?: string): Promise<JournalManage> => {
  if (journalCache || !tableName) return journalCache;
  journalTableName = tableName;
  journalCache = new JournalManage(journalTableName);
  const db = journalCache.getDb();
  try {
    await db.db.open();
  } catch (d) {
    await db.db.delete(); // 何かおかしいので、一度キャッシュを削除して作り直す
    journalCache = new JournalManage(journalTableName);
  }
  await classInit(journalCache, journalTableName);
  return journalCache;
};

/**
 * あらゆるクラスで利用する共通の初期化処理（メタ情報を書き込む）
 * @param cache {<T extends CacheManage>}
 * @param tableName {string}
 */
const classInit = async <T extends JournalManage> (cache: T, tableName: string) => {
  const db = cache.getDb();
  const latest = await db.meta.get('latest');
  if (typeof latest === 'undefined') {
    await db.meta.put({name: 'latest', value: {}});
  } else {
    cache.setLatestTimestampInfo(latest.value);
  }

  await db.meta.put({name: 'tableName', tableName});
};

export {getJournal};
